import { isAxiosError } from "axios";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Badge } from "react-bootstrap";

export const getBarrio = async (bar, setBar, id) => {
  setBar({ ...bar, loading: true });
  let response = await axios().get("barrio/" + id);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Barrio cargado", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const getBarrios = async (bar, setBar) => {
  setBar({ ...bar, loading: true });
  let response = await axios().get("barrios");
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Barrios cargados", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const getJefes = async (bar, setBar, id) => {
  setBar({ ...bar, loading: true });
  let response = await axios().get("barrio/jefes/" + id);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      //toast.success("Barrios cargados", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      //toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const setJefe = async (bar, setBar, datos) => {
  setBar({ ...bar, loading: true });
  let response = await axios().post("barrio/jefe", datos);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Jefe guardado", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const guardarBarrio = async (bar, setBar, datos) => {
  setBar({ ...bar, loading: true });
  let response = await axios().post("barrio", datos);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Barrio creado", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const actualizarBarrio = async (bar, setBar, datos, id) => {
  setBar({ ...bar, loading: true });
  let response = await axios().patch("barrio/" + id, datos);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Barrio actualizado", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const activarJefe = async (bar, setBar, jefe_id, barrio_id) => {
  setBar({ ...bar, loading: true });
  let response = await axios().patch("barrio/activar_jefe/" + barrio_id, { jefe_id: jefe_id });
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Jefe activado", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const dataTable = (data, abrir, setAbrir, setJefeId) => {
  const columns = [
    { field: "id", headerName: "#", width: 50, flex: 0.5 },
    {
      field: "nombre",
      headerName: "Nombre",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "telefono",
      headerName: "Teléfono",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "dni",
      headerName: "DNI",
      minWidth: 150,
      flex: 1,
    },
    /* {
      field: "activo",
      headerName: "Estado",
      minWidth: 150,
      flex: 1,
      renderCell: (p) => {
        return (
          <div>
            <Badge className={`${p.row.activo == "Activo" ? "bg-success" : "bg-danger"}`}>
              {p.row.activo}
            </Badge>
          </div>
        );
      },
    }, */
    {
      field: "activar",
      headerName: "Acción",
      renderCell: (p) => {
        return (
          <div>
            <button
              type="button"
              disabled={p.row.activo == "Activo"}
              className={`btn btn-sm ${p.row.activo == "Activo" ? "btn-success" : "btn-danger"} `}
              onClick={() => {
                setJefeId(p.row.id);
                setAbrir(true);
              }}
            >
              {p.row.activo == "Activo" ? "Activo" : "Activar"}
            </button>
          </div>
        );
      },
      minWidth: 120,
      flex: 1,
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      nombre: d.nombre,
      telefono: d.telefono,
      dni: d.dni,
      activo: d.activo,
      activar: d.id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      d.id?.toString().toLowerCase().includes(value) ||
      d.nombre?.toLowerCase().includes(value) ||
      d.direccion?.toLowerCase().includes(value) ||
      d.comision?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
